"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DayPicker = require("player-react-day-picker");
var Utils = require("player-core/utils");
var Globalization = require("player-globalization");
var player_react_portal_1 = require("player-react-portal");
var portal_position_1 = require("player-react-portal/build/portal-position");
var Navbar_1 = require("./components/Navbar");
require("./DatePicker.css");
var types_1 = require("../types");
var localeUtils = {
    formatDay: function (d) {
        return Globalization.Culture.day.standAlone.wide[d.getDay()] + ", " + d.getDate() + " " + Globalization.Culture.month[d.getMonth()] + " " + d.getFullYear();
    },
    formatMonthTitle: function (d) { return Globalization.Culture.formatDate(d, 'MMMM yyyy'); },
    formatMonthShort: function (d) { return Globalization.Culture.formatDate(d, 'MM/yyyy'); },
    formatWeekdayShort: function (weekDay, locale) { return Globalization.Culture.day.standAlone.short[weekDay]; },
    formatWeekdayLong: function (weekDay, locale) { return Globalization.Culture.day.standAlone.wide[weekDay]; },
    getFirstDayOfWeek: function (locale) { return Globalization.Culture.firstDay; },
    getMonths: function (locale) { return Globalization.Culture.month.standAlone.abbreviated; },
    getMonthsLong: function (locale) { return Globalization.Culture.month.standAlone.wide; }
};
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.ENTERKEY = 13;
        _this.DOWNKEY = 40;
        _this.UPKEY = 38;
        _this.TABKEY = 9;
        _this._classNames = {
            container: 'DayPicker',
            wrapper: 'DayPicker-wrapper',
            interactionDisabled: 'DayPicker--interactionDisabled',
            month: 'DayPicker-Month',
            navBar: 'DayPicker-NavBar',
            navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
            navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
            navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',
            caption: 'DayPicker-Caption',
            weekdays: 'DayPicker-Weekdays',
            weekdaysRow: 'DayPicker-WeekdaysRow',
            weekday: 'DayPicker-Weekday',
            body: 'DayPicker-Body',
            week: 'DayPicker-Week',
            day: 'DayPicker-Day',
            today: 'today',
            selected: 'selected',
            disabled: 'disabled',
            outside: 'outside'
        };
        _this._id = props.id || 'inp' + Utils.createUUID();
        _this._setPosition = _this._setPosition.bind(_this);
        _this._formatDate = _this._formatDate.bind(_this);
        _this._handleDayClick = _this._handleDayClick.bind(_this);
        _this._handleMonthOrYearClick = _this._handleMonthOrYearClick.bind(_this);
        _this._handleInputClick = _this._handleInputClick.bind(_this);
        _this._handleInputChange = _this._handleInputChange.bind(_this);
        _this._handleInputKeyup = _this._handleInputKeyup.bind(_this);
        _this._handleDayPickerKeyDown = _this._handleDayPickerKeyDown.bind(_this);
        _this._handleBlur = _this._handleBlur.bind(_this);
        _this._closeCalendar = _this._closeCalendar.bind(_this);
        _this._openCalendar = _this._openCalendar.bind(_this);
        _this._callChangeEvent = _this._callChangeEvent.bind(_this);
        _this._assignInputRef = _this._assignInputRef.bind(_this);
        _this._handleSelectorChange = _this._handleSelectorChange.bind(_this);
        _this._focusFirstDayOfMonth = _this._focusFirstDayOfMonth.bind(_this);
        _this.state = {
            value: _this.props.value ? _this._formatDate(_this.props.value) : '',
            selectedDay: _this.props.value || new Date(),
            selectedMonth: new Date(),
            isOpen: false,
            position: {
                top: 0,
                left: 0
            },
            currentSelector: _this.props.isMonthPicker ? types_1.Selector.MONTH : types_1.Selector.DAY
        };
        return _this;
    }
    DatePicker.prototype._focusElement = function (dayPickerRef, selector) {
        var refTimer;
        var tick = function (ref, selectorStr) {
            if (ref === null) {
                refTimer = window.setTimeout(function () { return tick(ref, selectorStr); }, 250);
            }
            else if (ref && ref['dayPicker']) {
                var prevBtn = ref['dayPicker'].querySelector(selectorStr);
                if (prevBtn) {
                    prevBtn.focus();
                }
                window.clearTimeout(refTimer);
            }
        };
        refTimer = window.setTimeout(function () { return tick(dayPickerRef, selector); }, 250);
    };
    /* istanbul ignore next */
    DatePicker.prototype._handleDayClick = function (day, modifiers) {
        var _this = this;
        if (modifiers.disabled) {
            return;
        }
        this.setState({
            value: this._formatDate(day),
            selectedDay: day,
            isOpen: false
        }, function () {
            _this._callChangeEvent();
        });
    };
    DatePicker.prototype._handleMonthOrYearClick = function (day) {
        var _this = this;
        if (this.props.isMonthPicker && this.state.currentSelector === types_1.Selector.MONTH) {
            this.setState({
                value: this._formatDate(day),
                selectedDay: day,
                isOpen: false
            }, function () {
                _this._callChangeEvent();
            });
        }
        else {
            this.setState({
                selectedDay: day
            }, function () {
                _this._callChangeEvent();
            });
        }
    };
    DatePicker.prototype._handleInputClick = function (event) {
        this._openCalendar(event);
    };
    DatePicker.prototype._handleInputChange = function (event) {
        var value = event.target.value;
        var parsedDate = this._parseDate(value);
        this.setState({
            value: value,
            selectedDay: parsedDate === null ? new Date() : parsedDate
        });
    };
    DatePicker.prototype._handleInputKeyup = function (event) {
        if (this._isNavKey(event.keyCode)) {
            this._openCalendar(event);
        }
        else if (event.keyCode === this.TABKEY) {
            var selector = '.DayPicker-NavButton--prev';
            this._focusElement(this._refDayPicker, selector);
        }
    };
    /* istanbul ignore next */
    DatePicker.prototype._handleDayPickerKeyDown = function (event) {
        if (event.keyCode === this.TABKEY &&
            !event.shiftKey &&
            event.target.className.indexOf('DayPicker-Day') >= 0) {
            this._closeCalendar();
        }
    };
    DatePicker.prototype._handleBlur = function () {
        var _a = this.props, onBlur = _a.onBlur, value = _a.value;
        var isOpen = this.state.isOpen;
        if (!isOpen) {
            this._callChangeEvent();
        }
        if (onBlur) {
            onBlur(value);
        }
    };
    DatePicker.prototype._openCalendar = function (event) {
        if (this.props.matchPositionToScroll && window.scrollY) {
            var top_1 = window.scrollY + event.currentTarget.getBoundingClientRect().top;
            var left = event.currentTarget.offsetLeft;
            this.setState({ position: { top: top_1, left: left } });
        }
        this.setState({ isOpen: true });
    };
    DatePicker.prototype._closeCalendar = function () {
        var _this = this;
        this.setState({
            isOpen: false,
            currentSelector: this.props.isMonthPicker ? types_1.Selector.MONTH : types_1.Selector.DAY
        }, function () {
            _this._callChangeEvent();
            _this._refInput.focus();
        });
        return {};
    };
    DatePicker.prototype._callChangeEvent = function () {
        if (this.props.onChange) {
            var value = this.state.value;
            var shouldClearIfNotValid = this.props.shouldClearIfNotValid;
            var date = this._parseDate(value);
            var isValid = (value.length === 0 && date === null) || (date !== null && value.length !== 0);
            if (shouldClearIfNotValid && !isValid) {
                this.setState({ value: '' });
            }
            this.props.onChange(date, value, isValid, this._id);
        }
    };
    DatePicker.prototype._isNavKey = function (keyCode) {
        return keyCode === this.ENTERKEY || keyCode === this.UPKEY || keyCode === this.DOWNKEY;
    };
    /* istanbul ignore next */
    DatePicker.prototype._formatDate = function (day) {
        switch (this.props.format) {
            case 'Short': {
                return Globalization.Culture.toShortDate(day);
            }
            case 'Medium': {
                return Globalization.Culture.toMediumDate(day);
            }
            case 'Long': {
                return Globalization.Culture.toLongDate(day);
            }
            case 'Full': {
                return Globalization.Culture.toFullDate(day);
            }
            case 'Universal': {
                return Globalization.Culture.toUniversalDate(day);
            }
            case 'MonthOnlyShort': {
                return localeUtils.formatMonthShort(day);
            }
            case 'MonthOnlyLong': {
                return localeUtils.formatMonthTitle(day);
            }
            default:
                return Globalization.Culture.toMediumDate(day);
        }
    };
    DatePicker.prototype._parseDate = function (date) {
        var newDate;
        switch (this.props.format) {
            case 'MonthOnlyShort':
                {
                    newDate = Globalization.Culture.parseDate(date, ['MM/yyyy']);
                }
                break;
            case 'MonthOnlyLong':
                {
                    newDate = Globalization.Culture.parseDate(date, ['MMMM yyyy']);
                }
                break;
            default:
                newDate = Globalization.Culture.parseDate(date);
        }
        if (newDate instanceof Date && !isNaN(newDate.valueOf())) {
            if (this.props.isMonthPicker || this.props.format === 'MonthOnlyShort' || this.props.format === 'MonthOnlyLong') {
                // Since user has selected only month and year, need to set date as 1
                newDate.setDate(1);
            }
            return newDate;
        }
        else {
            return null;
        }
    };
    DatePicker.prototype._setPosition = function (node) {
        var _this = this;
        requestAnimationFrame(function () {
            var position = portal_position_1.positionDropdown(_this._refCalendar, _this._refInput, document.body);
            _this.setState({ position: position });
        });
        return {};
    };
    DatePicker.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.value !== nextProps.value) {
            this.setState({
                value: nextProps.value ? this._formatDate(nextProps.value) : '',
                selectedDay: nextProps.value || new Date()
            });
        }
    };
    DatePicker.prototype._assignInputRef = function (r) {
        var onRef = this.props.onRef;
        if (onRef) {
            onRef(r);
        }
        return (this._refInput = r);
    };
    DatePicker.prototype._handleSelectorChange = function (nextSelector) {
        this.setState({
            currentSelector: nextSelector
        });
    };
    DatePicker.prototype._focusFirstDayOfMonth = function () {
        var selector = '.DayPicker-Day[role="gridcell"][tabindex="0"]';
        this._focusElement(this._refDayPicker, selector);
    };
    DatePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, ariaLabel = _a.ariaLabel, ariaLabeledBy = _a.ariaLabeledBy, label = _a.label, description = _a.description, errorMessage = _a.errorMessage, showLabel = _a.showLabel, isEnabled = _a.isEnabled, isRequired = _a.isRequired, placeholder = _a.placeholder, tag = _a.tag, width = _a.width, isMobile = _a.isMobile, tooltip = _a.tooltip, disabledDays = _a.disabledDays, showMonthYearPicker = _a.showMonthYearPicker;
        var _b = this.state, value = _b.value, isOpen = _b.isOpen, position = _b.position, selectedDay = _b.selectedDay, currentSelector = _b.currentSelector;
        var cssOuter = ['p-textbox', 'form-row'];
        var cssInput = ['p-input', 'p-bc-grey40', 'p-bg-hv-grey80', 'p-bc-f-blue50', 'p-ph-grey50', 'row-1'];
        var cssCalendar = ['p-calendar-panel', 'p-bc-grey40', 'p-br-md', 'p-bw-xs', 'p-bs-solid'];
        var accessibilityAttrInput = {};
        var dateIconProps = {
            className: "p-calendar p-icon-calendar" + (!isEnabled ? ' p-calendar-disabled' : '')
        };
        if (isRequired) {
            accessibilityAttrInput['aria-required'] = true;
            cssOuter.push('is-required');
        }
        if (!isEnabled) {
            accessibilityAttrInput['aria-disabled'] = true;
            cssOuter.push('is-disabled');
        }
        else {
            dateIconProps['onClick'] = this._handleInputClick;
            dateIconProps['onKeyUp'] = this._handleInputKeyup;
        }
        if (tooltip) {
            dateIconProps['title'] = tooltip;
        }
        if (errorMessage) {
            accessibilityAttrInput['aria-invalid'] = true;
            cssOuter.push('is-invalid');
            cssInput.push('p-b-error', 'p-bc-error50');
        }
        if (!showLabel) {
            cssOuter.push('label-hidden');
        }
        if (width) {
            cssInput.push(width.toLowerCase());
        }
        var dateField = (React.createElement("input", __assign({ ref: this._assignInputRef, className: cssInput.join(' '), id: this._id, type: isMobile ? 'date' : 'text', value: value, onKeyDown: this._handleInputKeyup, onChange: this._handleInputChange, onBlur: this._handleBlur, required: isRequired, disabled: !isEnabled, placeholder: placeholder, "aria-label": ariaLabel, "aria-labelledby": ariaLabeledBy }, accessibilityAttrInput)));
        if (showMonthYearPicker && this._classNames.wrapper.indexOf('custom') < 0) {
            this._classNames.wrapper = this._classNames.wrapper + " custom-navbar";
        }
        var classNames = Object.assign(this._classNames, { selected: 'p-bg-primary50 p-br-md p-t-light' });
        var dayPickerProps = {
            ref: function (r) {
                _this._refDayPicker = r;
            },
            classNames: classNames,
            onDayClick: this._handleDayClick,
            selectedDays: selectedDay,
            disabledDays: disabledDays,
            month: selectedDay,
            localeUtils: localeUtils,
            fixedWeeks: true,
            enableOutsideDays: true,
            onKeyDown: this._handleDayPickerKeyDown
        };
        if (showMonthYearPicker) {
            dayPickerProps['navbarElement'] = function (navbarProps) { return (React.createElement(Navbar_1.default, __assign({}, navbarProps, { navbarClassName: _this._classNames.navBar, currentSelector: currentSelector, date: selectedDay, onChange: _this._handleMonthOrYearClick, onCloseCalendar: _this._closeCalendar, onCloseSelector: _this._focusFirstDayOfMonth, onSelectorChange: _this._handleSelectorChange }))); };
            dayPickerProps['captionElement'] = function () { return null; };
        }
        return (React.createElement("div", { className: cssOuter.join(' '), "data-tag": tag },
            React.createElement("label", { htmlFor: this._id, className: "p-t-grey40" },
                label,
                isRequired && React.createElement("span", { className: "p-t-error50" }, "*")),
            React.createElement("div", { className: "p-input-wrapper" },
                dateField,
                React.createElement("span", __assign({}, dateIconProps)),
                React.createElement("div", null,
                    description && React.createElement("p", { className: "note" }, description),
                    React.createElement("div", { "aria-live": "assertive", role: "alert" }, errorMessage && React.createElement("p", { className: "error p-t-error50" }, errorMessage)))),
            !isMobile && (React.createElement(player_react_portal_1.Portal, { isOpened: isOpen, onOpen: this._setPosition, onClose: this._closeCalendar, closeOnEsc: true, closeOnOutsideClick: true },
                React.createElement("div", { ref: function (r) {
                        _this._refCalendar = r;
                    }, className: cssCalendar.join(' '), style: {
                        top: position.top,
                        left: position.left
                    } },
                    React.createElement(DayPicker, __assign({}, dayPickerProps)))))));
    };
    DatePicker.defaultProps = {
        id: '',
        label: '',
        placeholder: '',
        errorMessage: '',
        description: '',
        width: 'Block',
        isRequired: false,
        showLabel: true,
        isEnabled: true,
        onBlur: void 0,
        onChange: void 0,
        tag: '',
        ariaLabel: '',
        ariaLabeledBy: '',
        value: null,
        format: 'Medium',
        isMobile: false,
        tooltip: '',
        matchPositionToScroll: false,
        shouldClearIfNotValid: false,
        showMonthYearPicker: false,
        isMonthPicker: false
    };
    return DatePicker;
}(React.Component));
exports.default = DatePicker;
//# sourceMappingURL=DatePicker.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/date-picker/build/control/DatePicker.js
// module id = 165
// module chunks = 0 1